<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "../../components/shared/tab-body.scss";
</style>

<script>
  import Description from "../../components/shared/Description.svelte";
  import { activeProviderConfigStore, integrationStore } from "../../stores";
  import TabbedSection from "./components/TabbedSection/TabbedSection.svelte";
  import TopSection from "./components/TopSection/TopSection.svelte";

  $: providerTitle = $integrationStore.getProviderTitle();
  $: learnMoreLink = $integrationStore.getLearnMoreLink("contactSettings");

  $: description = {
    title: "Contact Settings",
    description: `Decide when and how a contact gets added into ${providerTitle}.`,
    learnMoreLink,
  };

  // Derive tab items from integration data
  $: tabItems =
    $activeProviderConfigStore?.syncKinds?.map((kind, index) => ({
      label: kind === "ClientContact" ? "CONTACT" : kind.toUpperCase(),
      slot: `tab${index}`,
      kind,
    })) || [];
</script>

<div class="contact-settings tab-body">
  <Description {...description} />
  <TopSection />
  {#if tabItems.length > 0}
    <TabbedSection {tabItems} toggleKeys={["onlyAddNotesAfterSync"]} />
  {/if}
</div>
